import React, { FunctionComponent } from 'react';
import type { Industry } from '../../../types/toppage';

type Props = {
  industries: Industry[];
};

export const Presentation: FunctionComponent<Props> = ({ industries }) => {
  return (
    <section className="sitetop-recruitment">
      <div className="sitetop-pickup-nav">
        <h2 className="sitetop-pickup-title">
          INDUSTRY<span className="sitetop-pickup-sub">業種から探す</span>
        </h2>
      </div>
      <div className="sitetop-location-container">
        <nav className="sitetop-industry">
          {industries.map((industry) => (
            <a
              key={industry.id}
              href={`companies/tag/${industry.path}`}
              className="sitetop-industry-parent-word"
              data-event="click"
              data-category="topcontent"
              data-value="from_industries"
            >
              {industry.name} ({industry.count})
            </a>
          ))}
        </nav>
      </div>
    </section>
  );
};
